const COMPONENT = 'cta-media';

export default () => {
  $(`.${COMPONENT}`).each((index, component) => {
    const $component = $(component);

    setTimeout(init, 200);

    function init() {
      $component
        .find('img')
        .each((index, image) => {
          const $image = $(image);
          const src = $image.data('src');
          $image.attr('src', src);
        });
    }
  });
}
